// this is to trigger CI
import { type AnyAction, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Kept with the previous Stripe room-payment example (`actions/payments`); see file comment there.
import { onPayRoom } from "../actions/payments";

/** @deprecated We are phasing out `redux` */
interface DefaultPageDialogContentState {
  contentType: "unknown";
  contentProps: Record<string, unknown>;
}

/** @deprecated We are phasing out `redux` */
export interface DeleteOrganizationDialogContentState {
  contentType: "delete-organization";
  contentProps: {
    organizationId: string;
    organizationName: string;
    onDelete?: () => void;
  };
}

/** @deprecated We are phasing out `redux` */
export type PageDialogContentState = DefaultPageDialogContentState | DeleteOrganizationDialogContentState;

/** @deprecated We are phasing out `redux` */
export interface AppState {
  isLoading: number;
  isPageDialogVisible: boolean;
  pageDialogContentState: PageDialogContentState;
  /**
   * @deprecated Previous Stripe room-payment redirect target. Set when `onPayRoom` starts;
   * read by success/cancel pages. Kept as part of that payment example — may reuse later.
   */
  paymentRoomId?: string;
}

/** @deprecated We are phasing out `redux` */
const initialState: AppState = {
  isLoading: 0,
  isPageDialogVisible: false,
  pageDialogContentState: {
    contentProps: {},
    contentType: "unknown",
  },
};

const slice = createSlice({
  extraReducers: (builder) =>
    builder
      // Previous Stripe room-payment example: remember which room to return to after checkout.
      .addCase(onPayRoom.pending, (state, action) => {
        state.paymentRoomId = action.meta.arg.roomId;
      })
      .addMatcher(
        (action: AnyAction) => action.type.endsWith("pending") && !String(action.type).startsWith("graphql."),
        (state: AppState) => {
          state.isLoading = state.isLoading + 1;
        },
      )
      .addMatcher(
        (action: AnyAction) =>
          (action.type.endsWith("fulfilled") || action.type.endsWith("rejected")) &&
          !String(action.type).startsWith("graphql."),
        (state: AppState) => {
          if (state.isLoading > 0) {
            state.isLoading = state.isLoading - 1;
          }
        },
      ),
  initialState,
  name: "app",
  reducers: {
    pageDialogClose: (state: AppState) => {
      state.isPageDialogVisible = false;
    },
    pageDialogOpen: (state: AppState, action: PayloadAction<PageDialogContentState>) => {
      state.isPageDialogVisible = true;
      state.pageDialogContentState = {
        ...action.payload,
      };
    },
  },
});

/** @deprecated We are phasing out `redux` */
export const {
  /** @deprecated We are phasing out `redux` */
  pageDialogClose,
  /** @deprecated We are phasing out `redux` */
  pageDialogOpen,
} = slice.actions;

/** @deprecated We are phasing out `redux` */
export default persistReducer(
  {
    // always use values from initialState, not localStorage
    blacklist: ["isLoading"],
    key: slice.name,
    storage,
  },
  slice.reducer,
);
